import { getGitHubToken } from './mini/gitHubToken';
import guid from './mini/guid';
import _ from 'lodash';

function fromBinary(str) {
    return decodeURIComponent(atob(str).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
}

function getHeaders() {
    return {
        "Content-Type": "application/json",
        "Accept": "application/vnd.github.v3+json",
        "Authorization": "token " + encodeURI(getGitHubToken())
    };
}

function handleErrors(json) {
    if (json.documentation_url) {
        throw new Error(json.message);
    }
}

export const GitHubApiHttp = {

    testToken() {
        return fetch(`https://api.github.com/`,
            { headers: getHeaders() })
            .then(response => response.json())
            .then(json => {
                handleErrors(json);
                return true;
            });
    },

    getOrganizations() {
        return fetch(`https://api.github.com/user/orgs?per_page=100`,
            { headers: getHeaders() })
            .then(response => response.json())
            .then(json => {
                handleErrors(json);
                return {
                    organizations: json.map(({ id, login }) => {
                        return {
                            id: id.toString(),
                            login,
                        };
                    })
                };
            });
    },

    getRepositories(page = 1) {
        return fetch(`https://api.github.com/user/repos?per_page=100&page=${page}`,
            { headers: getHeaders() })
            .then(response => response.json())
            .then(json => {
                handleErrors(json);
                return {
                    repositories: json.map(({ id, name, full_name, permissions, owner }) => {
                        return {
                            id: id.toString(),
                            name,
                            fullName: full_name,
                            permissions,
                            owner
                        };
                    })
                };
            });
    },

    getBranchesByRepository(repo) {
        return fetch(`https://api.github.com/repos/${repo}/branches?date=${Date.now()}`,
            { headers: getHeaders() })
            .then(response => response.json())
            .then(json => {
                handleErrors(json);
                return {
                    branches: json.map(({ name, commit }) => {
                        return {
                            id: guid(),
                            name,
                            commit
                        };
                    })
                };

            });
    },

    getFilesByBranch(repo, commitSha) {
        return fetch(`https://api.github.com/repos/${repo}/git/commits/${commitSha}`,
            { headers: getHeaders() })
            .then(response => response.json())
            .then(json => {
                handleErrors(json);
                return GitHubApiHttp.getFiles(json.tree.url);
            });
    },

    getFiles(treeUrl) {
        return fetch(treeUrl + "?recursive=1&per_page=100", { headers: getHeaders() })
            .then(response => response.json())
            .then(json => {
                handleErrors(json);
                return { files: [...json.tree] };
            });
    },

    getFileContent(fileUrl) {
        return fetch(fileUrl, { headers: getHeaders() })
            .then(response => response.json())
            .then(json => {
                handleErrors(json);
                return fromBinary(json.content);
            });
    },

    async makeInitCommit(repoUrl, message, branch, file) {
        const params = {
            "branch": branch,
            "message": message,
            "content": btoa(file.content)
        };
        const response = await fetch(`https://api.github.com/repos/${repoUrl}/contents/${file.path}`, {
            headers: getHeaders(),
            method: 'PUT',
            body: JSON.stringify(params)
        });
        return await response.json();
    },

    getTree(repoUrl, commitSha) {
        return fetch(`https://api.github.com/repos/${repoUrl}/git/commits/${commitSha}`, { headers: getHeaders() })
            .then(response => response.json())
            .then(json => {
                handleErrors(json);
                return json;
            });
    },

    async createFileTree(repoUrl, files, commitSha) {
        const _files = [...files].map(({ path, content, toDelete }) => ({
            path,
            ...(toDelete ? { sha: null } : { content }),
            "mode": "100644",
            "type": "blob"
        }));
        const createTree = { "base_tree": commitSha ? commitSha : _files, "tree": _files };
        const response = await fetch(`https://api.github.com/repos/${repoUrl}/git/trees`, {
            headers: getHeaders(),
            method: 'POST',
            body: JSON.stringify(createTree)
        });
        return await response.json();
    },

    async createCommit(repoUrl, message, sha, parent) {
        const commitCommand = {
            "message": message,
            "tree": sha,
            "parents": parent
        };
        const response = await fetch(`https://api.github.com/repos/${repoUrl}/git/commits`, {
            headers: getHeaders(),
            method: 'POST',
            body: JSON.stringify(commitCommand)
        });
        return await response.json();
    },

    async updateHead(repoUrl, branch, sha) {
        const updateHead = { "sha": sha, "force": true };
        const response = await fetch(`https://api.github.com/repos/${repoUrl}/git/refs/heads/${branch}`,
            {
                headers: getHeaders(),
                method: 'POST',
                body: JSON.stringify(updateHead)
            });
        return await response.json();
    },

    async revokeAppAccess() {
        const response = await fetch(`https://api.github.com/applications/1276d3b7aa714eee6ab8/grant`,
            {
                headers: getHeaders(),
                method: 'DELETE',
            });
        return await response.json();
    }
};
